;(function (angular, $) {
    'use strict';
    angular.module('digitickApp').controller('AsideMyShoppingCartController', ['$scope', 'ShoppingCartFactory', function ($scope, ShoppingCartFactory) {
        $scope.ShoppingCartFactory = ShoppingCartFactory;

        $scope.validateShoppingCart = function(){
            ShoppingCartFactory.validate();
        };

        $scope.clearAllShoppingCart = function(){
            ShoppingCartFactory.clear().then(function(data){
                $scope.refresh();
            }, function(msg){
                console.log(msg);
            });
        };

        $scope.clearShoppingCart = function(itemId){
            if (itemId < 0) {
                return false;
            }
            ShoppingCartFactory.clear(itemId).then(function(data){
                $scope.refresh();
            }, function(msg){
                console.log(msg);
            });
        };

        $scope.refresh = function(){
            ShoppingCartFactory.getShoppingCart().then(function(data){
                $scope.ShoppingCartFactory = ShoppingCartFactory;
            }, function(msg){
                console.log(msg);
            });
        };

        $scope.refresh();
    }]);
})(angular, jQuery);

function refreshShoppingCart() {
    var scope = angular.element($('*[side-panel="shopping-cart"]')).scope();
    scope.$apply(function(){
        scope.refresh();
    })
    return true;
}

//if (typeof refreshShoppingCart == 'function') { refreshShoppingCart(); }